import { render, staticRenderFns } from "./OnTableSSR.vue?vue&type=template&id=78319c3b&"
import script from "./OnTableSSR.vue?vue&type=script&lang=js&"
export * from "./OnTableSSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports